
import React from 'react';
import { PatientNewFlowInsuranceEditConfirmModalTemplate } from 'themes/application/facility-order-new-flow-insurance/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { PatientNewFlowInsuranceEditConfirmModalStore } from 'application/facility-order-new-flow-insurance/stores';

@setCurrentView((rootStore, componentProps) => new PatientNewFlowInsuranceEditConfirmModalStore(rootStore, componentProps), 'patientNewFlowInsuranceEditConfirmModalStore')
@observer
class PatientNewFlowInsuranceEditConfirmModal extends React.Component {
    render() {
        return <PatientNewFlowInsuranceEditConfirmModalTemplate {...this.props} />
    }
}

export default PatientNewFlowInsuranceEditConfirmModal;
